import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
export const paradaService = { getParadasExcel, getEnviosByParada,
  getParadas,
  getEtiquetaPDFByParada,
  sendEmailEtiquetasByParada,
  newEventoParada,
  estadosParada,
  getImages,
  getJustificantePDFByParada,
  getParada,
  getPayload,
};

function getParada(paradaId) {
  const axios = createAxios();
  let urlPath = `/parada/${paradaId}`;
  return axios.get(urlPath);
}

function getPayload(idParada) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/payload`;
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    return Promise.resolve({
      blob: response.data,
      fileName: contentDisposition,
    });
  });
}

function paramsParadas(filters = {}) {
  const params = new URLSearchParams({ vista: filters.vista || "" });
  if (filters.date && filters.date.length === 2) {
    params.set("fecha_inicio", filters.date[0]); params.set("fecha_fin", filters.date[1]);
  }
  ["idCliente", "numero", "referenciaCourier", "courier", "codigoPostal"].forEach((key) => {
    if (filters[key]) params.set(key, filters[key]);
  });
  if (filters.idFranquicia) params.set("franquiciaId", filters.idFranquicia);
  if (filters.estados && filters.estados.length) params.set("estados", filters.estados.join());
  if (filters.conIncidencia === true) params.set("conIncidencia", "true");
  if (filters.sort) { params.set("sort", filters.sort.prop); params.set("order", filters.sort.order); }
  return params;
}

function getParadas(pagination, filters = {}) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const params = paramsParadas(filters);
  params.set("page", pagination ? pagination.currentPage - 1 : 0);
  params.set("limit", pagination ? pagination.perPage : 10);
  return axios.get(`/franquiciadora/${user.extraData.franquiciadoraId}/paradas?${params.toString()}`);
}

function getParadasExcel(filters = {}) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const params = paramsParadas(filters);
  return axios.get(`/franquiciadora/${user.extraData.franquiciadoraId}/paradas/excel?${params.toString()}`, { responseType: "blob" });
}

function getEtiquetaPDFByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/etiqueta/download`;
  return axios.get(urlPath, { responseType: "blob" });
}

function sendEmailEtiquetasByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/etiqueta/mail`;
  return axios.get(urlPath);
}

function newEventoParada(idParada, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/estados`;
  return axios.post(urlPath, body);
}

function estadosParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/estados`;
  return axios.get(urlPath);
}

function getImages(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${id}/imagenes`;
  return axios.get(urlPath);
}
function getJustificantePDFByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/parada/${idParada}/justificante`;
  return axios.get(urlPath, {
    responseType: "blob",
  });
}

function getEnviosByParada(id, pagination) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  return axios.get(`/franquiciadora/${user.extraData.franquiciadoraId}/parada/${id}/envios?page=${pagination.currentPage - 1}&limit=${pagination.perPage}`);
}
